
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesGrid extends Serenity.EntityGrid<ECommSalesRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommSales'; }
        protected getDialogType() { return ECommSalesDialog; }
        protected getIdProperty() { return ECommSalesRow.idProperty; }
        protected getInsertPermission() { return ECommSalesRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommSalesRow.localTextPrefix; }
        protected getService() { return ECommSalesService.baseUrl; } 
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
            this.toolbar.findButton('add-button').find('.button-inner').text('New Invoice');
            this.slickGrid.setOptions({ rowHeight: 30 });

            //this.addButtonClick();
        }

        protected addButtonClick() {
            
            let now = new Date();
            var voucher = FormatHelper.GetVoucherNo(87);

            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[87].AutoPosting;
            this.editItem(<ECommSalesRow>{
                VoucherNo: voucher,
                Line_No: 0,
                VoucherTypeId: 87,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                TransDate: now.toDateString(),
                AutoPosting: autoposting
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        } 

        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}